import React, { useEffect, useState, Fragment } from 'react';
import { CheckIcon } from 'lucide-react';
export function Pricing() {
  const [selectedPlan, setSelectedPlan] = useState<'basic' | 'pro'>('pro');
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (num: number) => String(num).padStart(2, '0');
  const checkoutLinks = {
    basic: 'https://checkout.tusbeneficios.shop/cart/51281997267177:1',
    pro: 'https://checkout.tusbeneficios.shop/cart/51281997857001:1'
  };
  const goToCheckout = () => {
    window.location.href = checkoutLinks[selectedPlan];
  };
  return <section id="precios" className="bg-navy text-white py-12 px-6" data-id="element-213">
      <div className="max-w-md mx-auto space-y-8" data-id="element-214">
        <div className="text-center space-y-4" data-id="element-215">
          <div className="text-sm opacity-80" data-id="element-216">🕐 ESTA OFERTA TERMINA EN</div>

          <div className="flex justify-center gap-2" data-id="element-217">
            {[{
            value: timeLeft.hours,
            label: 'HORAS'
          }, {
            value: timeLeft.minutes,
            label: 'MIN'
          }, {
            value: timeLeft.seconds,
            label: 'SEG'
          }].map((item, index) => <Fragment key={item.label} data-id="element-218">
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 min-w-[70px]" data-id="element-219">
                  <div className="text-4xl font-bold" data-id="element-220">{pad(item.value)}</div>
                  <div className="text-xs opacity-60 mt-1" data-id="element-221">{item.label}</div>
                </div>
                {index < 2 && <div className="text-3xl font-bold self-center" data-id="element-222">:</div>}
              </Fragment>)}
          </div>
        </div>

        <div className="text-center space-y-2" data-id="element-223">
          <h2 className="text-2xl font-bold" data-id="element-224">ELEGÍ TU KIT VETERINARIO ELITE</h2>
          <p className="text-sm text-teal-bright" data-id="element-225">
            Ambas opciones incluyen los 4 bonos completos
          </p>
        </div>

        <div className="space-y-4" data-id="element-226">
          <button onClick={() => setSelectedPlan('basic')} className={`w-full text-left rounded-xl p-6 transition-all ${selectedPlan === 'basic' ? 'bg-white/10 border-2 border-teal-bright' : 'bg-white/5 border-2 border-white/10'}`} data-id="element-227">
            <div className="flex items-start justify-between mb-3" data-id="element-228">
              <div className="flex items-center gap-3" data-id="element-229">
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'basic' ? 'border-teal bg-teal' : 'border-white/30'}`} data-id="element-230">
                  {selectedPlan === 'basic' && <div className="w-3 h-3 bg-white rounded-full" data-id="element-231" />}
                </div>
                <div data-id="element-232">
                  <div className="font-bold text-lg" data-id="element-233">
                    🐾 KIT VETERINARIO ELITE
                  </div>
                  <div className="text-sm opacity-80" data-id="element-234">6 tomos + 4 bonos</div>
                </div>
              </div>
            </div>
            <div className="flex items-baseline gap-2" data-id="element-235">
              <span className="text-sm line-through opacity-60" data-id="element-236">$39.000</span>
              <span className="text-3xl font-bold" data-id="element-237">$19.990</span>
            </div>
          </button>

          <button onClick={() => setSelectedPlan('pro')} className={`w-full text-left rounded-xl p-6 transition-all relative ${selectedPlan === 'pro' ? 'bg-white/10 border-2 border-teal-bright' : 'bg-white/5 border-2 border-white/10'}`} data-id="element-238">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2" data-id="element-239">
              <div className="bg-gold text-navy px-4 py-1 rounded-full text-xs font-bold whitespace-nowrap" data-id="element-240">
                ⭐ MÁS ELEGIDO
              </div>
            </div>

            <div className="flex items-start justify-between mb-3" data-id="element-241">
              <div className="flex items-center gap-3" data-id="element-242">
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'pro' ? 'border-teal bg-teal' : 'border-white/30'}`} data-id="element-243">
                  {selectedPlan === 'pro' && <div className="w-3 h-3 bg-white rounded-full" data-id="element-244" />}
                </div>
                <div data-id="element-245">
                  <div className="font-bold text-lg" data-id="element-246">🚀 KIT ELITE PRO</div>
                  <div className="text-sm opacity-80" data-id="element-247">
                    6 tomos + 4 bonos + módulo financiero avanzado
                  </div>
                  <div className="text-xs text-teal-bright font-semibold mt-1" data-id="element-248">
                    AHORRÁS $31.000
                  </div>
                </div>
              </div>
            </div>
            <div className="flex items-baseline gap-2" data-id="element-249">
              <span className="text-sm line-through opacity-60" data-id="element-250">$49.000</span>
              <span className="text-3xl font-bold" data-id="element-251">$27.990</span>
            </div>
          </button>
        </div>

        <button onClick={goToCheckout} className="w-full bg-teal text-white h-14 rounded-xl font-bold text-lg hover:bg-teal/90 transition-colors" data-id="element-252">
          {selectedPlan === 'pro' ? 'SÍ, QUIERO EL KIT ELITE PRO →' : 'SÍ, QUIERO EL KIT ELITE →'}
        </button>

        <p className="text-center text-sm opacity-80" data-id="element-253">
          {selectedPlan === 'pro' && 'La opción más elegida por clínicas que quieren crecer'}
        </p>

        <div className="text-center text-sm opacity-80 pt-4 space-x-2" data-id="element-254">
          <span data-id="element-255">🔒 Pago seguro</span>
          <span data-id="element-256">·</span>
          <span data-id="element-257">⚡ Acceso inmediato</span>
          <span data-id="element-258">·</span>
          <span data-id="element-259">🛡️ Garantía 7 días</span>
        </div>
      </div>
    </section>;
}